export default __webpack_public_path__ + "static/media/Skips.906be28d.svg";